import axios from "../../utils/Axios";

export const deleteJob = async (id) => {
    const response = await axios.delete(`/jobs/${id}`);
    return response.config?.url?.slice(6);
}